import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "@/styles/index.scss";
import "@/styles/responsive.scss";
import "@/service/alert";
import VueMask from "v-mask";
import moment from "moment";
import store from "./store";
import "@/service/table";
import YimoVueEditor from "yimo-vue-editor";
import VueCoreVideoPlayer from "vue-core-video-player";
import VueSocialSharing from "vue-social-sharing";

Vue.use(VueSocialSharing);
Vue.use(VueCoreVideoPlayer);
Vue.use(VueMask);
Vue.use(ElementUI, {
  locale,
});
Vue.use(YimoVueEditor, {
  // name: 'v-editor-app',//Custom name
  config: {
    // uploadImgUrl:process.env.VUE_APP_BASE_URL_API+'upload/imgmsg', // upload api
    printLog: false, // disabled console.log
    // lang: YimoVueEditor.E.langs.en, // lang config
    // pasteText: true,
    // pasteFilter: true,
    // hideLinkImg: true,
    colors: {
      "#000000": "Black",
      "#333333": "Light Black",
      "#6E6E6E": "Drak Grey",
      "#909399": "Grey",
      "#00469B": "Rhenus Blue",
      "#00C88C": "Lime",
      "#FABB00": "Rhenus Yellow",
      "#C81800": "Red",
    },
    lang: {
      bold: "Bold",
      underline: "Underline",
      italic: "Italic",
      forecolor: "Color",
      bgcolor: "Backcolor",
      strikethrough: "Strikethrough",
      eraser: "Eraser",
      source: "Codeview",
      quote: "Quote",
      fontfamily: "Font family",
      fontsize: "Font size",
      head: "Head",
      orderlist: "Ordered list",
      unorderlist: "Unordered list",
      alignleft: "Align left",
      aligncenter: "Align center",
      alignright: "Align right",
      link: "Insert link",
      linkTarget: "Open mode",
      text: "Text",
      submit: "Submit",
      cancel: "Cancel",
      unlink: "Unlink",
      table: "Table",
      emotion: "Emotions",
      img: "Image",
      uploadImg: "Upload",
      linkImg: "Link",
      video: "Video",
      width: "width",
      height: "height",
      location: "Location",
      loading: "Loading",
      searchlocation: "search",
      dynamicMap: "Dynamic",
      clearLocation: "Clear",
      langDynamicOneLocation: "Only one location in dynamic map",
      insertcode: "Insert Code",
      undo: "Undo",
      redo: "Redo",
      fullscreen: "Full screnn",
      openLink: "open link",
      uploadPlaceTxt: "uploading__",
      uploadTimeoutPlaceTxt: "upload_timeout__",
      uploadErrorPlaceTxt: "upload_error__",
    },
    codeDefaultLang: "javascript",
    menus: [
      "source",
      "|",
      "bold",
      "underline",
      "italic",
      "strikethrough",
      "eraser",
      "forecolor",
      // 'bgcolor',
      "|",
      // "quote",
      // 'fontfamily',
      // "fontsize",
      // 'head',
      "unorderlist",
      "orderlist",
      "alignleft",
      "aligncenter",
      "alignright",
      "|",
      "link",
      // 'unlink',
      // "table",
      // 'emotion',
      // "|",
      // "img",
      // 'video',
      // 'insertcode',
      "|",
      "undo",
      "redo",
      "fullscreen",
    ],
    // customUpload: true,
    // customUploadInit: uploadInit,
    //   uploadImgFns:{onload :(resultText, xhr) =>{
    //     // // resultText 服务器端返回的text
    //     // // xhr 是 xmlHttpRequest 对象，IE8、9中不支持

    //     // // 上传图片时，已经将图片的名字存在 editor.uploadImgOriginalName
    //     // var originalName = editor.uploadImgOriginalName || '';

    //     // // 如果 resultText 是图片的url地址，可以这样插入图片：
    //     // editor.command(null, 'insertHtml', '<img src="' + resultText + '" alt="' + originalName + '" style="max-width:100%;"/>');
    //     // // 如果不想要 img 的 max-width 样式，也可以这样插入：
    //     // // editor.command(null, 'InsertImage', resultText);
    // }},
  }, //wagnEditor config

  uploadHandler: (type, resTxt) => {
    //Upload processing hook
    if (type === "success") {
      var res = JSON.parse(resTxt); //Do not process the default look at the return value bit image path
      return process.env.VUE_APP_BASE_URL_API + res;
    } else if (type === "error") {
      //todo toast
    } else if (type === "timeout") {
      //todo toast
    }
    return "upload failed__";
  },
});

Vue.config.productionTip = false;

Vue.filter("dateTh", function(date) {
  let res = "";
  if (typeof date === "undefined" || date === null || date === "") {
    res = "-";
  } else {
    res = moment(date)
      .locale("th")
      .format("LL");

    let dateMoment = moment(date)
      .locale("th")
      .format("LL");
    res = dateMoment.replace(
      /[0-9]+[0-9]+[0-9]+[0-9]/g,
      new Date(date).getFullYear() + 543
    );
  }
  return res;
});
Vue.filter("dateThFullNumber", function(date) {
  let res = "";
  if (typeof date === "undefined" || date === null || date === "") {
    res = "-";
  } else {
    let dateMoment = moment(date)
      .locale("th")
      .format("LL");
    res = dateMoment.replace(
      /[0-9]+[0-9]+[0-9]+[0-9]/g,
      new Date(date).getFullYear() + 543
    );
  }
  return res;
});

Vue.filter("dateThFull", function(date) {
  let res = "";
  if (typeof date === "undefined" || date === null || date === "") {
    res = "-";
  } else {
    let dateMoment = moment(date)
      .locale("th")
      .format("LL");
    res = dateMoment.replace(
      /[0-9]+[0-9]+[0-9]+[0-9]/g,
      "พ.ศ. " + (new Date(date).getFullYear() + 543)
    );
  }
  return res;
});

Vue.filter("dateTimeThShort", function(date) {
  let res = "";
  if (typeof date === "undefined" || date === null || date === "") {
    res = "-";
  } else {
    let dateMoment = moment(date)
      .locale("th")
      .format("lll น.");
    let sortYear = new Date(date).getFullYear() + 543;
    res = dateMoment.replace(
      /[0-9]+[0-9]+[0-9]+[0-9]/g,
      sortYear.toString().slice(2, 4)
    );
  }
  return res;
});

Vue.filter("dateTimeTh", function(date) {
  let res = "";
  if (typeof date === "undefined" || date === null || date === "") {
    res = "-";
  } else {
    let dateMoment = moment(date)
      .locale("th")
      .format("LLL น.");
    let sortYear = new Date(date).getFullYear() + 543;
    res = dateMoment.replace(/[0-9]+[0-9]+[0-9]+[0-9]/g, sortYear.toString());
  }
  return res;
});

Vue.filter("dateThNumber", function(date) {
  let res = "";
  if (typeof date === "undefined" || date === null || date === "") {
    res = "-";
  } else {
    res = moment(date)
      .locale("th")
      .format("l");
  }
  return res;
});

Vue.filter("striphtml", function(value) {
  var div = document.createElement("div");
  div.innerHTML = value;
  var text = div.textContent || div.innerText || "";
  return text;
});

Vue.filter("commaNoDot", (value) => {
  if (
    typeof value === "undefined" ||
    value === null ||
    value === "" ||
    value === 0
  ) {
    return 0;
  } else {
    value = value.toFixed(0);
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
